import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "..";

import useBanners from "../../views/ArticlesPage/useBanners";

import "./PageHeader.scss";

function PageHeader({
  breadcrumbs,
  title,
  subtitle,
  backgroundSrc,
  mobileBackgroundSrc,
  isBalck,
  hasOverlay,
  showSubtitleOnMobile,
  slug,
}) {
  const { banner } = useBanners({ slug });
  const desktopBackground = banner ? banner.file : backgroundSrc;
  const mobileBackground = banner
    ? banner.file
    : mobileBackgroundSrc || backgroundSrc;

  return (
    <div
      className={classnames("PageHeader", {
        "PageHeader--black": isBalck,
        "PageHeader--overlay": hasOverlay,
        "PageHeader--subtitle-mobile": showSubtitleOnMobile,
      })}
      style={{
        "--page-header-bg": `url("${desktopBackground}")`,
        "--page-header-bg-mobile": `url("${mobileBackground}")`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12}>
            <Breadcrumbs
              currentName={breadcrumbs.currentName}
              path={breadcrumbs.path}
            />
            <header>
              <h1>{title}</h1>
              <h3>{subtitle}</h3>
            </header>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

PageHeader.propTypes = {
  backgroundSrc: PropTypes.string,
  mobileBackgroundSrc: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  breadcrumbs: PropTypes.shape({
    currentName: PropTypes.string.isRequired,
    path: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        url: PropTypes.string,
      })
    ),
  }),
  isBalck: PropTypes.bool,
  hasOverlay: PropTypes.bool,
  showSubtitleOnMobile: PropTypes.bool,
};

PageHeader.defaultProps = {
  breadcrumbs: {
    currentName: "",
    path: [],
  },
  backgroundSrc: "",
  mobileBackgroundSrc: "",
  isBalck: false,
  hasOverlay: false,
  showSubtitleOnMobile: false,
};

export default PageHeader;
